import { useIsNewBillingPageEnabled } from "../hooks/useIsNewBillingPageEnabled";
import { NewBillingDetails } from "./NewBillingDetails";
import { OldBillingDetails } from "./OldBillingDetails";

interface BillingDetailsProps {
  forceFromSubscription?: boolean;
  showAddons?: boolean;
  showBillingDetails?: boolean;
  showBillingPortal?: boolean;
}

export const BillingDetails = (props: BillingDetailsProps) => {
  const isNewBillingPageEnabled = useIsNewBillingPageEnabled();

  if (isNewBillingPageEnabled) {
    return <NewBillingDetails {...props} />;
  }

  return <OldBillingDetails {...props} />;
};
